import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocationInitialUrl {
  private initialUrl: string;

  init() {
    this.initialUrl = window.location.href;
  }

  getInitialUrl() {
    return this.initialUrl;
  }
}
